module.exports = __webpack_public_path__ + "static/media/settings.e78c7373.svg";